/* eslint-disable react/no-unknown-property */
/* eslint-disable complexity */
import Card from '@taglivros/oef_componentes/build/components/card'
import Button from '@taglivros/oef_componentes/build/components/button'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import React, { Fragment, useState } from 'react'
import { bool, func, object } from 'prop-types'
import EnderecoForm from '../../../../components/EnderecoForm/EnderecoForm'
import { navigate } from '@reach/router'
import styled from 'styled-components'
import { useGlobal } from '../../../../contexts/GlobalContext'
import { formatCEP } from '../../../../utils/formatter/formatter'
import { getInformacoesModalidadePorAssinatura } from '../../../../utils/helpers/helpersAssinatura'

const BotaoVerMaisWrapper = styled.div`
  max-width: 170px;
  overflow: hidden;
  position: absolute;
  right: 20px;
  top: 31px;

  span {
    font-weight: bold;
    font-size: 15px;
    -webkit-text-decoration-line: underline;
    text-decoration-line: underline;
    color: #009bbf;
    cursor: pointer;
  }
`

const BotaoExcluirWrapper = styled.div`
  button {
    font-size: 16px;
    margin: 20px 25px;
    padding: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
  }
`

const EnderecoCardWrapper = styled.div`
  ${( { desabilitado } ) => desabilitado && `opacity: 0.2;`}
  position: relative;
  width: 100%;
`

const Titulo = styled.h2`
  ${StyleGuide.tipografia.titulo2};
  margin: 0;

  @media (max-width: ${StyleGuide.mediaQuery.smallpc}) {
    font-size: 18px;
  }
`

const TituloNovoEndereco = styled.h6`
  ${StyleGuide.tipografia.textoPequeno};
  ${StyleGuide.boldFonte};
  color: ${StyleGuide.cores.azul};
  margin: 0 0 20px;

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    ${StyleGuide.tipografia.textoHelper};
    ${StyleGuide.boldFonte};
    color: ${StyleGuide.cores.azul};
    margin: 0 0 15px;
  }
`

const Conteudo = styled.div`
  .enredeco__conteudo {
    ${StyleGuide.tipografia.textoDefault};
    line-height: 1.6;
    margin: 0.5em 0;
  }
`

const CardEnderecoEntrega = ( {
  ativo,
  botaoEditar,
  botaoExcluir,
  botaoVerMais,
  desabilitado,
  endereco,
  hasHover,
  isEnderecoVigente,
  onClickCard,
  onConfirmar,
  onExcluir,
  showModalidadeTitulo,
  tituloHomeModalidade,
  tituloNovoEndereco
} ) => {
  const { modalidadeURL } = useGlobal()
  const [ openForm, setOpenForm ] = useState( false )
  const modalidadeEndereco =
    modalidadeURL && getInformacoesModalidadePorAssinatura( modalidadeURL )

  const handleClick = () => {
    navigate( `${modalidadeURL}/entrega` )
  }
  const handleClickConfirmar = enderecoRetornado => {
    setOpenForm( false )
    onConfirmar( enderecoRetornado )
  }

  return (
    <EnderecoCardWrapper desabilitado={ desabilitado }>
      <Card
        ativo={ ativo }
        className="card"
        data-testid="card-endereco-entrega"
        hover={
          hasHover
            ? `box-shadow: 0px 0px 0px 2px ${StyleGuide.cores.azul}`
            : null
        }
        largura="100%"
        margin="0 0 30px 0"
        onClick={ !openForm ? onClickCard : null }
      >
        {
          botaoVerMais ?
            <BotaoVerMaisWrapper>
              <span
                invertido
                noBackground
                onClick={ event => {
                  event.stopPropagation()
                  handleClick()
                } }
              >
                Ver mais
              </span>
            </BotaoVerMaisWrapper> : null
        }

        {openForm ? (
          <EnderecoForm
            botoesAcao
            endereco={ endereco }
            onCancelar={ () => setOpenForm( false ) }
            onConfirmar={ enderecoRetornado => handleClickConfirmar( enderecoRetornado ) }
          />
        ) : (
          <Fragment>
            {ativo && !tituloNovoEndereco && isEnderecoVigente ? <TituloNovoEndereco>Endereço vigente</TituloNovoEndereco> : null}

            {
              tituloNovoEndereco ?
                <TituloNovoEndereco>
                  A partir do próximo mês seu kit será entregue neste endereço
                </TituloNovoEndereco> : null
            }

            {showModalidadeTitulo && ativo && modalidadeEndereco ?
              <Titulo>
                {`Endereço de entrega Kit ${modalidadeEndereco.visualizacao}`}
              </Titulo> : null}

            {tituloHomeModalidade ? <Titulo>Entrega</Titulo> : null}

            {!showModalidadeTitulo && !tituloHomeModalidade && (
              <Titulo>Endereço</Titulo>
            )}

            {endereco.id ? (
              <Conteudo>
                <p className="endereco__conteudo">
                  {`${endereco.rua}, ${endereco.numero}`}

                  {endereco.complemento ? ` / ${endereco.complemento}` : null}
                </p>

                <p className="endereco__conteudo">
                  {`Bairro ${endereco.bairro} - ${endereco.cidade}/${endereco.uf}`}
                </p>

                <p className="endereco__conteudo">
                  {`CEP ${formatCEP( endereco.cep )}`}
                </p>
              </Conteudo>
            ) : (
              <p>Você não possui um endereço vigente</p>
            )}
          </Fragment>
        )}

        {
          botaoEditar && !openForm ?
            <Button
              onClick={ event => {
                event.stopPropagation()
                setOpenForm( !openForm )
              } }
              tema={ Button.BOTAO_CURADORIA }
            >
              Editar
            </Button> : null
        }

        {
          botaoExcluir && !openForm ?
            <BotaoExcluirWrapper>
              <Button
                noBackground
                onClick={ event => {
                  event.stopPropagation()
                  onExcluir()
                } }
                tema={ Button.BOTAO_CURADORIA }
              >
                excluir
              </Button>
            </BotaoExcluirWrapper> : null
        }
      </Card>
    </EnderecoCardWrapper>
  )
}

CardEnderecoEntrega.propTypes = {
  'ativo': bool,
  'botaoEditar': bool,
  'botaoExcluir': bool,
  'botaoVerMais': bool,
  'desabilitado': bool,
  'endereco': object.isRequired,
  'hasHover': bool,
  'isEnderecoVigente': bool,
  'onClickCard': func,
  'onConfirmar': func,
  'onExcluir': func,
  'showModalidadeTitulo': bool,
  'tituloHomeModalidade': bool,
  'tituloNovoEndereco': bool
}

CardEnderecoEntrega.defaultProps = {
  'ativo': false,
  'botaoEditar': false,
  'botaoExcluir': false,
  'botaoVerMais': true,
  'desabilitado': false,
  'hasHover': false,
  'isEnderecoVigente': false,
  'onClickCard': () => {},
  'onConfirmar': () => {},
  'onExcluir': () => {},
  'showModalidadeTitulo': false,
  'tituloHomeModalidade': false,
  'tituloNovoEndereco': false
}

export default CardEnderecoEntrega
